import React, { useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import SideBarButtonSVG from "./SVG/SideBarButtonSVG";
import CartDrawer from "./Cart/CartDrawer";
import { useDispatch } from "react-redux";
import { delayNavigation } from "../helpers/helpers";
import { Projects } from "../Data/Data";
import LogoSVG from "./SVG/LogoSVG";

const Header = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [menuIsShown, setMenuIsShown] = useState(false);

  const location = useLocation();

  return (
    <div
      className={`${
        location.pathname.includes("projects") ? "sticky" : "fixed"
      } top-0 left-0 w-screen bg-gray-700  h-14 z-[100] grid grid-cols-12 gap-6`}
    >
      <div
        className="hidden xl:flex items-center justify-center col-start-2 col-span-1  h-full cursor-pointer"
        onClick={() => {
          delayNavigation(dispatch, navigate, "/");
        }}
      >
        {/* <Logo h={80} w={120} /> */}
        <LogoSVG w={60} h={40} />
        {/* <img src={LogoSvgFile} alt="" className="text-primary-orange" /> */}
      </div>
      <div
        className="flex items-center justify-center xl:hidden col-start-1 col-span-4 h-full"
        onClick={() => {
          delayNavigation(dispatch, navigate, "/");
        }}
      >
        {/* <Logo h={60} w={70} /> */}
        <LogoSVG w={50} h={30} />
      </div>
      {location.pathname.includes("projects/greenhome/block") ||
      location.pathname.includes("projects/greenhome/apartments") ||
      location.pathname.includes("projects/nikea/block") ||
      location.pathname.includes("projects/nikea/apartments") ? null : ( // </> //   )} //     /> //       setSelectMenuIsShown={setSelectMenuIsShown} //     <SearchSelectCartDrawer //   {selectMenuIsShown && ( //   </div> //     </motion.p> //       ბინები //     > //       }} //         setSelectMenuIsShown(true); //         //setIsAnimating(true); //       onHoverStart={() => { //       }`} //         selectMenuIsShown ? "z-10" : "" //       } text-2xl tracking-[4px] opacity-100 cursor-pointer group ${ //         selectMenuIsShown ? "text-primary-dark" : "text-primary-light" //       className={`font-extrabold ${ //     <motion.p //   <div className=" hidden xl:flex items-center justify-center col-start-6 col-span-2  text-primary-light group"> // <>
        <div className=" hidden xl:flex xl:flex-col items-center justify-center gap-2 col-start-4 col-span-4  text-primary-light ">
          <h1 className="tracking-wide">აირჩიე შენი სახლი</h1>
          <div className="flex items-center justify-center gap-4 font-gilroy font-light ">
            {Projects.map((project, index) => {
              return (
                <Link
                  key={project.id}
                  to={"/projects"}
                  className={`relative tracking-[3px] opacity-100 cursor-pointer group`}
                  onClick={(event) => {
                    delayNavigation(
                      dispatch,
                      navigate,
                      `/projects/${project.name}/block`,
                      event
                    );
                  }}
                >
                  <span className="text-primary-orange">{index + 1}.</span>{" "}
                  {project.label}
                  <span className="absolute bottom-0 left-0 w-0 h-[2px] bg-white transition-all duration-500 group-hover:w-full"></span>
                </Link>
              );
            })}
          </div>
        </div>
      )}

      <ul className="hidden md:flex flex-row items-center justify-end gap-5 col-start-5 col-span-7  xl:col-start-8 xl:col-span-4 h-full text-sm text-primary-light list-none animate-slideInRight duration-300 ">
        <li className="relative group w-max cursor-pointer">
          <Link
            to={"/"}
            onClick={(event) => {
              delayNavigation(dispatch, navigate, "/", event);
            }}
          >
            მთავარი გვერდი
          </Link>
          <span className="absolute bottom-0 left-0 w-0 h-[3px] bg-primary-light transition-all duration-500 group-hover:w-full"></span>
        </li>

        <li className="relative group">
          <Link
            to={"/about"}
            onClick={(event) => {
              delayNavigation(dispatch, navigate, "/about", event);
            }}
          >
            K2 Invest{" "}
          </Link>
          <span className="absolute bottom-0 left-0 w-0 h-[3px] bg-primary-light transition-all duration-500 group-hover:w-full"></span>
        </li>

        <li className="relative group">
          <Link
            to={"/projects"}
            onClick={(event) => {
              delayNavigation(dispatch, navigate, "/projects", event);
            }}
          >
            პროექტები
          </Link>
          <span className="absolute bottom-0 left-0 w-0 h-[3px] bg-primary-light transition-all duration-500 group-hover:w-full"></span>
        </li>
        <li className="relative group">
          <Link
            to={"/news"}
            onClick={(event) => {
              delayNavigation(dispatch, navigate, "/news", event);
            }}
          >
            სიახლეები
          </Link>
          <span className="absolute bottom-0 left-0 w-0 h-[3px] bg-primary-light transition-all duration-500 group-hover:w-full"></span>
        </li>
      </ul>
      <div
        className={`flex flex-row items-center justify-center md:hidden col-start-10 col-span-1 h-full w-9  ${
          menuIsShown ? "text-primary-orange" : "text-primary-light"
        } ${menuIsShown ? "-rotate-45" : "rotate-0"}
         ${
           menuIsShown ? "scale-75" : "scale-100"
         } rounded-full duration-500 ease-linear`}
        onClick={() => setMenuIsShown(true)}
      >
        <SideBarButtonSVG />
      </div>
      {menuIsShown && <CartDrawer setIsDrawerOpen={setMenuIsShown} />}
    </div>
    /* </div> */
  );
};

export default Header;
